import React, { useEffect, useState } from "react";
import AppRoutes from "./routes/AppRoutes";
import { ThemeProvider } from "@mui/material";
import theme from "./utlis/theme";
import AlertNotification from "./components/AlertNotification";

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [employeeInfo, setEmployeeInfo] = useState(null);
  const [scanData, setScanData] = useState([]);
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(true);
  const [isMobileDevice, setIsMobileDevice] = useState(null); // Initialize as null

  // useEffect(() => {
  //   const checkMobile = () => {
  //     // Synchronous checks
  //     const userAgent = navigator.userAgent.toLowerCase();
  //     const platform = navigator.platform.toLowerCase();

  //     // Touch capability
  //     const isTouchDevice =
  //       "ontouchstart" in window || navigator.maxTouchPoints > 0;

  //     // User agent check
  //     const isMobileUA =
  //       /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
  //         userAgent
  //       );

  //     // Platform check
  //     const isMobilePlatform =
  //       platform.startsWith("iphone") ||
  //       platform.startsWith("ipad") ||
  //       (platform.includes("linux") &&
  //         (platform.includes("android") || platform.includes("arm"))) ||
  //       platform.startsWith("android") ||
  //       /winarm/i.test(platform);

  //     // Screen size check
  //     const isSmallScreen = window.innerWidth <= 768;

  //     // Input capabilities
  //     const isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
  //     const hasHoverNone = window.matchMedia("(hover: none)").matches;

  //     return (
  //       isTouchDevice &&
  //       isMobileUA &&
  //       isMobilePlatform &&
  //       isSmallScreen &&
  //       isCoarsePointer &&
  //       hasHoverNone
  //     );
  //   };

  //   // Async check for User Agent Client Hints if available
  //   const checkMobileWithHints = async () => {
  //     if (navigator.userAgentData) {
  //       try {
  //         const uaData = await navigator.userAgentData.getHighEntropyValues([
  //           "platform",
  //         ]);
  //         const platform = uaData.platform.toLowerCase();
  //         const isMobilePlatformHint =
  //           platform.startsWith("android") ||
  //           platform.startsWith("ios") ||
  //           platform.includes("iphone") ||
  //           platform.includes("ipad");

  //         if (!isMobilePlatformHint) {
  //           setIsMobileDevice(false);
  //           return;
  //         }
  //       } catch (e) {
  //         console.error("Error getting high-entropy values:", e);
  //       }
  //     }

  //     setIsMobileDevice(checkMobile());
  //   };

  //   checkMobileWithHints();
  // }, []);

  // if (isMobileDevice === null) {
  //   return null; // Or loading spinner
  // }

  // if (!isMobileDevice) {
  //   return (
  //     <div style={{ textAlign: "center", marginTop: "50px" }}>
  //       <h1>This website is only accessible on mobile devices.</h1>
  //     </div>
  //   );
  // }

  useEffect(() => {
    const isTouchDevice =
      "ontouchstart" in window || navigator.maxTouchPoints > 0;

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Check for mobile devices with real touch capabilities
    if (
      isTouchDevice &&
      /android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      ) &&
      window.innerWidth <= 768
    ) {
      setIsMobileDevice(true);
    } else {
      setIsMobileDevice(false);
    }
  }, []);

  if (!isMobileDevice) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <h1>This website is only accessible on mobile devices.</h1>
      </div>
    );
  }

  return (
    <div>
      <ThemeProvider theme={theme}>
        <AlertNotification />
        <AppRoutes
          isAuthenticated={isAuthenticated}
          setIsAuthenticated={setIsAuthenticated}
          employeeInfo={employeeInfo}
          setEmployeeInfo={setEmployeeInfo}
          scanData={scanData}
          setScanData={setScanData}
          setIsAdminAuthenticated={setIsAdminAuthenticated}
          isAdminAuthenticated={isAdminAuthenticated}
          setIsAdmin={setIsAdmin}
          isAdmin={isAdmin}
        />
      </ThemeProvider>
    </div>
  );
};

export default App;
